/**
 * Accordion Toggle for Main Navigation CTAs
 */
document.addEventListener("DOMContentLoaded", function () {
	// Find the toggle button within button containers
	const toggleButton = document.querySelector(
		".button-container .nav-cta-toggle"
	);
	// Select ALL elements with the class 'ctas' inside '.button-container'
	const toggleButtonsNodeList = document.querySelectorAll(
		".button-container .ctas"
	);

	// Check if the main toggle button exists AND if the NodeList is not empty
	if (toggleButton && toggleButtonsNodeList.length > 0) {
		// Function to toggle the button panel
		const toggleButtonPanel = () => {
			const isExpanded =
				toggleButton.getAttribute("aria-expanded") === "true";
			toggleButton.setAttribute("aria-expanded", !isExpanded);

			// Iterate over each element in the NodeList and toggle the class
			toggleButtonsNodeList.forEach((buttonGroup) => {
				buttonGroup.classList.toggle("active");
			});
		};

		// Function to close the button panel
		const closeButtonPanel = () => {
			toggleButton.setAttribute("aria-expanded", "false");

			// Iterate over each element in the NodeList and remove the class
			toggleButtonsNodeList.forEach((buttonGroup) => {
				buttonGroup.classList.remove("active");
			});
		};

		// Event listener for the main toggle button
		toggleButton.addEventListener("click", toggleButtonPanel);

		// Event listener to close the panel when clicking outside
		document.addEventListener("click", (event) => {
			// Check if the click is outside the main toggle AND outside ALL elements in the NodeList
			let isClickInsideAnyToggleButton = false;
			toggleButtonsNodeList.forEach((buttonGroup) => {
				if (buttonGroup.contains(event.target)) {
					isClickInsideAnyToggleButton = true;
				}
			});

			// Also need to check if ANY of the button groups have the active class
			let isActive = false;
			toggleButtonsNodeList.forEach((buttonGroup) => {
				if (buttonGroup.classList.contains("active")) {
					isActive = true;
				}
			});

			if (
				!toggleButton.contains(event.target) &&
				!isClickInsideAnyToggleButton &&
				isActive // Check if any are active before trying to close
			) {
				closeButtonPanel();
			}
		});
	} else {
		// Optional: Log if elements aren't found for debugging
		if (!toggleButton)
			console.warn(
				"nav-button.js: '.button-container .nav-cta-toggle' not found."
			);
	}
});
